<body>
    
   
    <div class="sidebar">
            <div class="sidebar-brand">
                <h2>
                <img src="../../assets/images/marketingApp-logo.png">
                </h2>
            </div>
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <a>
                         <div class="inactive-img" (click)="click='dashboard'"  [ngClass]="{ 'active' : click=='dashboard' }">
                            <div><img src="../../assets/images/dashboard.svg"></div>
                            <span>Dashboard</span>
                        </div>
                        </a>
                    </li>
                    <li>
                        <a>
                         <div class="inactive-img"  (click)="click='agency';route()"  [ngClass]="{ 'active' : click=='agency' }">
                            <div><img src="../../assets/images/agency.svg" height="34px"></div>
                            <span>Agency</span>
                        </div>
                        </a>
                    </li>
                    <li>
                        <a>
                          <div class="inactive-img"  (click)="click='settings';route()"  [ngClass]="{ 'active' : click=='settings' }">
                            <div><img src="../../assets/images/settings.svg"></div>
                            <span>Settings</span>
                           </div>
                        </a>
                    </li>
                </ul>


   <div class="last-icon">
    <div class="sec-one">
        <img [src]="this.storedData.photo?this.storedData.photo:'../../../../assets/images/user1.jpeg'"  >
        <div class="user-sec">
        <p>{{this.storedData.name}}</p>
        <span>Super Admin</span>
       </div>
    </div>
    <div class="sec-two" (click)="popUp=true">
        <div class="log-div"><img src="../../assets/images/logout.png"></div>
        <p>Logout</p>
    </div>
</div>




            </div>
    </div>

 

    <!-- <div class="main-wrapper">
    <div class="main-content">
            <header>
           
                    <div class="head-line">
                 
                        <p>Dash Board</p>
                    </div>
                <div class="user-wrapper">
                   <p>Skillplex Technologies</p>
                  
                    <div>
                        <img class="log1" src="../../assets/images/Ellipse 2.png">
                    </div>
                </div>
            </header>
            
            <main class="main-2">

               <div class="container">
                <div class="projects">
                        <div class="card1">
                          
                        

                        </div>
                        <div class="col-12 footer-div">
                            <img src="../../assets/images/accruon-logo.png">
                        </div>
                    </div>
                   
            </div>

    
            </main>
   
    </div>
    </div> -->

     <!-- Code begins here -->
   <!-- <a href="#" class="float" id="float-w">
    <img src="../../../assets/images/whatsapp.svg" class="my-float">
   </a> -->


 <!--Popup start-->

 <div id="add-enquiry" class="overlay" *ngIf="popUp">
    <div class="popup-ins" id="popup-ins1">
        <div class="ins-f" id="ins-f1">
        <h2>Confirmation </h2>
            <p class="table-h1">Are you sure you want to Log Out ? </p>
      
    
  
    </div>
  
        <div class="ins-footer">
    <button class="btn-sec" (click)="popUp=false">Cancel</button>
    <button class="btn-prime" (click)="logOut()">Log Out</button>
    </div>
  
    </div>
  </div>
  
   
   <!--Popup end-->




<!------->

</body>